import React from "react";
import { PushStatusFilter, Role, UserRole } from "@myapp/contract";
import { FieldWrapper } from "../../../shared/ui";
import { FilterBar } from "../../../shared/ui/layouts/FilterBar";
import { Input } from "../../../shared/ui/controls/Input/Input";
import Select from "../../../shared/ui/controls/Select/Select";
import { MultiSelectDropdown } from "../../../shared/ui/controls/MultiSelectDropdown/MultiSelectDropdown";
import { pushUserColumns } from "../model/constants";

interface Props {
  search: string;
  onSearchChange: (value: string) => void;
  roles: UserRole[];
  onRolesChange: (value: UserRole[]) => void;
  pushStatus: PushStatusFilter;
  onPushStatusChange: (value: PushStatusFilter) => void;
}

const ROLE_OPTIONS: { value: UserRole; label: string }[] = [
  { value: Role.WORKER, label: "Handwerker" },
  { value: Role.MANAGER, label: "Büroangestellter" },
  { value: Role.DIRECTOR, label: "Leiter" },
  { value: Role.SUPERUSER, label: "Superadmin" },
];

const PUSH_STATUS_OPTIONS = [
  { label: "Mit Push", value: "with" },
  { label: "Ohne Push", value: "without" },
  { label: "Alle", value: "all" },
];

export const PushUserFilterBar: React.FC<Props> = ({
  search,
  onSearchChange,
  roles,
  onRolesChange,
  pushStatus,
  onPushStatusChange,
}) => {
  return (
    <FilterBar columns={pushUserColumns}>
      <FieldWrapper label="" />
      <FieldWrapper label="Name">
        <Input value={search} onChange={onSearchChange} placeholder="Suchen…" clearable />
      </FieldWrapper>
      <FieldWrapper label="Rolle">
        <MultiSelectDropdown<UserRole>
          value={roles}
          onChange={onRolesChange}
          options={ROLE_OPTIONS}
        />
      </FieldWrapper>
      <FieldWrapper label="Geräte">
        <Select
          options={PUSH_STATUS_OPTIONS}
          value={pushStatus}
          onChange={(v) => onPushStatusChange(v as PushStatusFilter)}
        />
      </FieldWrapper>
    </FilterBar>
  );
};
